import Upcoming from "../assets/projects/UPCOMING.png";
import Padel from "../assets/projects/padel.png";
import HabitHero from "../assets/projects/habit-hero.png";

export const data = [
  {
    id: 1,
    name: "Mexicano Padel",
    image: Padel,
    github: "https://github.com/AndreasHoegh/mexicano-padel",
    live: "https://www.padelamericano.org/",
  },
  {
    id: 2,
    name: "HabitHero",
    image: HabitHero,
    github: "https://github.com/AndreasHoegh/habit-hero",
    live: "https://habit-hero-a95q2j3hm-andreas-projects-624247a7.vercel.app/",
  },
  {
    id: 3,
    name: "Next.js Dashboard",
    image: Upcoming,
    github: "https://github.com/AndreasHoegh/nextjs-dashboard",
    live: "",
  },
  {
    id: 4,
    name: "upcoming",
    image: Upcoming,
    github: "",
    live: "",
  },
];
